import React, { useEffect } from "react";

/**
 * PageReloadManager Component
 * Place this component in your root App component
 */
const PageReloadManager = ({ maxIdleHours = 24 }) => {
  useEffect(() => {
    const maxIdleTime = maxIdleHours * 60 * 60 * 1000; // Convert hours to milliseconds
    const STORAGE_KEY = "lastPageActivity";

    const checkAndReload = () => {
      const lastActivity = localStorage.getItem(STORAGE_KEY);

      if (lastActivity) {
        const timeDiff = Date.now() - parseInt(lastActivity, 10);

        if (timeDiff >= maxIdleTime) {
          console.log(`Page inactive for ${maxIdleHours} hours. Reloading...`);
          localStorage.removeItem(STORAGE_KEY);
          window.location.reload();
          return true;
        }
      }

      // Update last activity time
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
      return false;
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkAndReload();
      }
    };

    const handleBeforeUnload = () => {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    };

    // Check on mount
    checkAndReload();

    // Add listeners
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", checkAndReload);
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", checkAndReload);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [maxIdleHours]);

  return null; // This component doesn't render anything
};

export default PageReloadManager;
